'use strict';

var _classCallCheck = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/inherits");

var lp = require('pull-length-prefixed');

var Pushable = require('pull-pushable');

var pull = require('pull-stream');

var setImmediate = require('async/setImmediate');

var EventEmitter = require('events');

var rpc = require('./message').rpc.RPC;
/**
 * The known state of a connected peer.
 */


var Peer =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(Peer, _EventEmitter);

  /**
   * @param {PeerInfo} info
   */
  function Peer(info) {
    var _this;

    _classCallCheck(this, Peer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Peer).call(this));
    /**
     * @type {PeerInfo}
     */

    _this.info = info;
    /**
     * @type {Connection}
     */

    _this.conn = null;
    /**
     * @type {Set}
     */

    _this.topics = new Set();
    /**
     * @type {Pushable}
     */

    _this.stream = null;
    _this._references = 0;
    return _this;
  }
  /**
   * Is the peer connected currently?
   *
   * @type {boolean}
   */


  _createClass(Peer, [{
    key: "write",

    /**
     * Send a message to this peer.
     * Throws if there is no `stream` to write to available.
     *
     * @param {Buffer} msg
     * @returns {undefined}
     */
    value: function write(msg) {
      if (!this.isWritable) {
        var id = this.info.id.toB58String();
        throw new Error('No writable connection to ' + id);
      }

      this.stream.push(msg);
    }
    /**
     * Attach the peer to a connection and setup a write stream
     *
     * @param {Connection} conn
     * @returns {undefined}
     */

  }, {
    key: "attachConnection",
    value: function attachConnection(conn) {
      var _this2 = this;

      this.conn = conn;
      this.stream = new Pushable();
      pull(this.stream, lp.encode(), conn, pull.onEnd(function () {
        _this2.conn = null;
        _this2.stream = null;

        _this2.emit('close');
      }));
      this.emit('connection');
    }
  }, {
    key: "_sendRawSubscriptions",
    value: function _sendRawSubscriptions(topics, subscribe) {
      if (topics.size === 0) {
        return;
      }

      var subs = [];
      topics.forEach(function (topic) {
        subs.push({
          subscribe: subscribe,
          topicCID: topic
        });
      });
      this.write(rpc.encode({
        subscriptions: subs
      }));
    }
    /**
     * Send the given subscriptions to this peer.
     * @param {Set|Array} topics
     * @returns {undefined}
     */

  }, {
    key: "sendSubscriptions",
    value: function sendSubscriptions(topics) {
      this._sendRawSubscriptions(topics, true);
    }
    /**
     * Send the given unsubscriptions to this peer.
     * @param {Set|Array} topics
     * @returns {undefined}
     */

  }, {
    key: "sendUnsubscriptions",
    value: function sendUnsubscriptions(topics) {
      this._sendRawSubscriptions(topics, false);
    }
    /**
     * Send messages to this peer.
     *
     * @param {Array<any>} msgs
     * @returns {undefined}
     */

  }, {
    key: "sendMessages",
    value: function sendMessages(msgs) {
      this.write(rpc.encode({
        msgs: msgs
      }));
    }
    /**
     * Bulk process subscription updates.
     *
     * @param {Array} changes
     * @returns {undefined}
     */

  }, {
    key: "updateSubscriptions",
    value: function updateSubscriptions(changes) {
      var _this3 = this;

      changes.forEach(function (subopt) {
        if (subopt.subscribe) {
          _this3.topics.add(subopt.topicCID);
        } else {
          _this3.topics.delete(subopt.topicCID);
        }
      });
    }
    /**
     * Closes the open connection to peer
     *
     * @param {Function} callback
     * @returns {undefined}
     */

  }, {
    key: "close",
    value: function close(callback) {
      var _this4 = this;

      // Force removal of peer
      this._references = 1; // End the pushable

      if (this.stream) {
        this.stream.end();
      }

      setImmediate(function () {
        _this4.conn = null;
        _this4.stream = null;

        _this4.emit('close');

        callback();
      });
    }
  }, {
    key: "isConnected",
    get: function get() {
      return Boolean(this.conn);
    }
    /**
     * Do we have a connection to write on?
     *
     * @type {boolean}
     */

  }, {
    key: "isWritable",
    get: function get() {
      return Boolean(this.stream);
    }
  }]);

  return Peer;
}(EventEmitter);

module.exports = Peer;